import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {UrlBuilderService} from "@feature/common";
import { saveAs } from "file-saver";

@Component({
  selector: 'mojo-download-mft-bulk-upload-result',
  templateUrl: './download-mft-bulk-upload-result.component.html'
})
export class DownloadMftBulkUploadResultComponent implements OnInit {

  constructor(
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute,
    private readonly urlBuilder: UrlBuilderService) {}

  ngOnInit(): void {
    const jobInstanceId = this.route.snapshot.queryParams['jobInstanceId'];
    const fileName = this.route.snapshot.queryParams['fileName'];
    const downloadUrl = this.urlBuilder.getIdentityServerUrl(`mftbulkuploadresult/${jobInstanceId}`);
    this.http.get(downloadUrl, { responseType: 'blob' }).subscribe(data => saveAs(data, fileName));
  }
}
